import React from "react";
import { DECISION_META } from "./decisionMeta";

export default function ReviewScreen({ players, picks, confidences = {}, onEdit }) {
    const decided = players.filter((p) => picks[String(p.playerId)]).length;
    const remaining = players.length - decided;
    return (
        <section className="border border-fa-cream/30 bg-[#0d0d0d] p-5 space-y-3" data-testid="review-screen">
            <div className="flex items-baseline justify-between flex-wrap gap-2">
                <div>
                    <div className="font-mono text-[10px] uppercase tracking-widest text-fa-yellow">
                        Review your picks
                    </div>
                    <h3 className="font-display font-black text-2xl uppercase tracking-tight mt-1">
                        {decided} of {players.length} decided
                    </h3>
                </div>
                {remaining > 0 && (
                    <span className="font-mono text-[10px] uppercase tracking-widest text-[#FF6B6B]" data-testid="review-remaining">
                        {remaining} still need a call
                    </span>
                )}
            </div>
            <div className="space-y-1" data-testid="review-list">
                {players.map((p, i) => {
                    const pick = picks[String(p.playerId)];
                    const conf = confidences[String(p.playerId)] ?? 50;
                    const meta = pick ? DECISION_META[pick] : null;
                    return (
                        <div
                            key={p.playerId}
                            className={`flex items-center justify-between gap-3 py-2 px-3 border-l-2 ${pick ? "" : "border-[#FF6B6B]"}`}
                            style={pick ? { borderLeftColor: meta?.color } : undefined}
                            data-testid={`review-row-${i}`}
                        >
                            <div className="flex-1 min-w-0">
                                <div className="font-display font-black text-sm truncate">{p.webName}</div>
                                <div className="font-mono text-[10px] text-white/40">
                                    {p.display?.subtitle}
                                </div>
                            </div>
                            {pick && (
                                <span
                                    className="font-mono text-[9px] uppercase tracking-widest text-white/40 tabular-nums"
                                    data-testid={`review-conf-${i}`}
                                >
                                    {conf}% · {(0.5 + conf / 100).toFixed(2)}×
                                </span>
                            )}
                            <button
                                type="button"
                                onClick={() => onEdit(i)}
                                data-testid={`review-edit-${i}`}
                                className="font-mono text-[10px] uppercase tracking-widest hover:text-white"
                                style={pick ? { color: meta?.color } : { color: "#FF6B6B" }}
                            >
                                {pick || "DECIDE →"}
                            </button>
                        </div>
                    );
                })}
            </div>
            <div className="font-mono text-[10px] text-white/40 pt-2 border-t border-white/5">
                Scroll down to lock in your picks · or tap any row to revise.
            </div>
        </section>
    );
}
